import React from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import PaginationFooter from '../../../components/PaginationFooter';
import EditionRecipientsFilters from './EditionRecipientsFilters';
import EditionRecipientsTable from './EditionRecipientsTable';
import useEditionRecipients from '../../hooks/useEditionRecipients';
import { editionTitle } from '../../changelogAdminConfig';

/**
 * Quem recebeu um envio: situação do envio, quando abriu e em que clicou.
 * Abertura é aproximada (leitores que bloqueiam imagens não contam; alguns abrem sozinhos).
 * @param {{ edition: Object|null, onClose: Function }} props - edition null = fechado
 */
function EditionRecipientsDialog({ edition, onClose }) {
  const {
    recipients, pagination, isLoading, error,
    filters, setFilter, searchInput, setSearchInput, setPage, hasActiveFilters,
  } = useEditionRecipients(edition ? edition.id : null);

  return (
    <Dialog open={Boolean(edition)} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="caption" color="text.secondary" component="div">Destinatários · {editionTitle(edition)}</Typography>
        <Typography variant="subtitle1" component="div" sx={{ fontWeight: 600 }}>{edition?.subject || 'Novidades da Gabriela'}</Typography>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <EditionRecipientsFilters
          filters={filters}
          onFilterChange={setFilter}
          searchInput={searchInput}
          onSearchInputChange={setSearchInput}
        />
        {error && <Alert severity="error" sx={{ borderRadius: 0 }}>{error}</Alert>}
        <EditionRecipientsTable recipients={recipients} isLoading={isLoading} hasActiveFilters={hasActiveFilters} />
        <PaginationFooter pagination={pagination} onPageChange={setPage} itemLabel="destinatários" />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between', px: 3 }}>
        <Typography variant="caption" color="text.secondary">
          Abertura é aproximada: quem bloqueia imagens não conta e alguns leitores abrem sozinhos.
        </Typography>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditionRecipientsDialog;
